import { render, staticRenderFns } from "./component-item.vue?vue&type=template&id=5350067d"
import script from "./component-item.vue?vue&type=script&lang=ts"
export * from "./component-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports